import type { PocInputValidity } from 'commons/types';

export const STATUS_TRACKING_TRANSLATION_PREFIX = 'settings.devices.device-settings-configuration-status-tracking';
export const STATUS_TRACKING_CHANGE_DEBOUNCE_MS = 200;

export const VALID_STATUS_TRACKING_STATE: PocInputValidity = { state: 'valid' };
export const INVALID_STATUS_TRACKING_STATE: PocInputValidity = { state: 'error', type: ['custom'] };

export const STATUS_TRACKING_ERRORS_MAPPINGS: { errorCode: string; translationKey: string }[] = [
    {
        errorCode: 'E_POC_ADM_DM_00189',
        translationKey:
            'settings.devices.device-settings-configuration-status-tracking.connectivity.error.negativeHours',
    },
];
